import { inject, Injectable } from "@angular/core";
import { AUTH_SVC, AuthService, ProjectService } from "@company-box/services";
import { FXAuthService } from "./fx-auth.service";
import { ContainerFile, Pageable, Project } from "@company-box/models";

@Injectable({
  providedIn: "root",
})
export class FedexProjectService extends ProjectService {
  private authService: AuthService = inject(AUTH_SVC);

  constructor() {
    super();
  }

  // Override base methods with FedEx-specific implementations
  override listProjects(
    _userId: number,
    page: number,
    options: SearchOptions = {
      includeUser: false,
      includeType: false,
      createdBy: "ALL",
    }
  ): Promise<Pageable<Project>> {
    return new Promise((resolve, reject) => {
      (this.authService as FXAuthService).getCurrentUser().then(
        (user: { id: any }) => {
          // this.logger.debug('Loading projects');
          let url = `${this.environment.apiHost}/project/design/${user.id}/list/page?`;

          if (page > 0) {
            const offset = page - 1;
            url += `offset=${offset}&`;
          }

          url += `limit=${options.pageSize ? options.pageSize : "10"}&includeType=${
            options.includeType ? options.includeType : "false"
          }&
                subcategory=${options.subcategory ? options.subcategory : "false"}&designType=${
            options.designType ? options.designType : "ALL"
          }&`;

          url += `sort=-createdTime`;
          this.httpClient.get(url).subscribe(
            (response: any) => {
              const list: Project[] = [];
              (response.content as any[]).forEach((object) => {
                const project: Project = new Project().deserialize(object);
                list.push(project);
              });
              const result: Pageable<Project> = new Pageable<Project>().deserialize(response);
              result.content = list;
              this.logger.debug("Loaded projects", result);
              resolve(result);
            },
            (error) => {
              this.logger.debug(error.message || error);
              reject(error.message || error);
            }
          );
        },
        (reason: any) => {
          this.logger.debug(reason);
          reject(reason);
        }
      );
    });
  }

  // FedEx-specific methods
  deleteDesignFile(file: ContainerFile): Promise<boolean> {
    return new Promise((resolve, reject) => {
      (this.authService as FXAuthService).getCurrentUser().then(
        (user: { id: any }) => {
          const url = `${this.environment.apiHost}/project/container/${file.containerName}/design/${file.shortName}/?userId=${user.id}`;
          this.httpClient.delete(url, {}).subscribe(
            (_response: any) => {
              this.logger.debug("Deleted file from container", file.shortName, file.containerName);
              resolve(true);
            },
            (error) => {
              this.logger.debug(error.message || error);
              reject(false);
            }
          );
        },
        (error: { message: any }) => {
          this.logger.debug(error.message || error);
          reject(false);
        }
      );
    });
  }

  getDesignForContainer(containerId: any, user: { id: any }) {
    const url = `${this.environment.apiHost}/project/design/${user.id}/container/${containerId}`;
    return new Promise((resolve, reject) => {
      this.httpClient.get(url).subscribe(
        (design) => {
          resolve(design);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  getDesignForUser(designId: any, user: { id: any }) {
    const url = `${this.environment.apiHost}/project/design/${user.id}/${designId}`;
    return new Promise((resolve, reject) => {
      this.httpClient.get(url).subscribe(
        (design) => {
          resolve(design);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }
}

export interface SearchOptions {
  includeUser?: boolean;
  includeType?: boolean;
  createdBy?: string;
  pageSize?: number | 10;
  subcategory?: string;
  designType?: string;
  preset?: string;
}
